<template>
  <div class="menu-page">
    <div>
      <dashboard-nav></dashboard-nav>
      <div class="d-flex">
        <div class="nav-view">
          <main-nav></main-nav>
        </div>

        <!-- VIEW START -->
        <div class="main-view" v-if="dataReady">
          <breadcrumb :crumb="name"></breadcrumb>
          <div class="intro-wrapper main-x-spacing pb-2">
            <h2>{{ title }}</h2>
          </div>
          <!-- main view -->
          <div class="main-body-content main-x-spacing">
            <v-row>
              <v-col cols="10" class="body-middle-col pt-0">
                <!-- {{ userData }} -->
                <v-row class="pt-5">
                  <v-col cols="4">
                    <div class="text-uppercase">subscription & billing</div>
                  </v-col>
                  <v-col cols="8">
                    <div class="d-flex justify-space-between">
                      <b>{{ userData.email || "No Email" }}</b>
                      <span><a href="#">Change Email</a></span>
                    </div>
                    <div class="d-flex justify-space-between">
                      <div>Password: *****</div>
                      <span>
                        <a href="#" @click="openChangePassword">
                          Change Password
                        </a>
                      </span>
                    </div>

                    <hr class="mt-5 mb-3" />

                    <div class="d-flex justify-space-between">
                      <div>Your next billing date is</div>
                      <span><a href="#">Manage payment info</a></span>
                    </div>
                    <div class="d-flex justify-space-between">
                      <b>... ... ... 1234</b> <v-spacer></v-spacer>
                      <span><a href="#">Change billing details</a></span>
                    </div>
                  </v-col>
                </v-row>

                <hr class="mt-5 mb-3" />

                <v-row>
                  <v-col cols="4">
                    <div class="text-uppercase">Plan Details</div>
                    <v-btn
                      :ripple="false"
                      disabled
                      depressed
                      width="40%"
                      :loading="deleteLoader"
                      large
                      class="gen-button btn-outlined no-Btn-bg"
                      @click="$router.push('/general-settings/account')"
                    >
                      <span>Cancel Subscription</span>
                    </v-btn>
                  </v-col>
                  <v-col cols="8">
                    <div class="d-flex justify-space-between">
                      <div>Basic Plan</div>
                      <!-- <span><a href="#">Change Plan</a></span> -->
                    </div>

                    <hr class="mt-5 mb-3" />

                    <div class="d-flex justify-space-between">
                      <b>Add Ons</b>
                      <span><a href="#">Change add ons</a></span>
                    </div>
                    <div>
                      <div>Delivery Manager</div>
                      <div>POS Extra</div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="2" class="col-2-side-tab col-2-side-tab-right">
                <div class="side-tab-child pt-5">
                  <h4>Don't Click unless you know are doing!!!</h4>
                  <v-btn
                    :ripple="false"
                    depressed
                    width="100%"
                    :loading="deleteLoader"
                    large
                    class="gen-button btn-outlined no-Btn-bg"
                    @click="$router.push('/general-settings/account')"
                  >
                    <span>Delete Account</span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- Upload List -->
          <v-row justify="center" class="openDialogWrapper">
            <v-dialog
              v-model="openDialog"
              fullscreen
              max-width="50%"
              transition="scroll-x-reverse-transition"
              class="openDialog"
            >
              <v-card
                max-width="50%"
                tile
                class="ml-auto dialogCard"
                height="100%"
              >
                <div v-if="changePasswordActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Change Password</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <div class="form-group">
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            v-model="oldPassword"
                            hide-details
                            placeholder="Enter your current password"
                            height="25"
                            outlined
                            dense
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show1 ? 'text' : 'password'"
                            @click:append="show1 = !show1"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="password"
                            placeholder="Enter new password"
                            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show2 ? 'text' : 'password'"
                            @click:append="show2 = !show2"
                            hide-details
                            height="25"
                            outlined
                            dense
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="confirmPassword"
                            placeholder="Confirm new password"
                            :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show3 ? 'text' : 'password'"
                            @click:append="show3 = !show3"
                            hide-details
                            height="25"
                            outlined
                            dense
                            :rules="[rules.required, rules.passwordMatch]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                  </v-form>
                  <div class="dialogAction text-right">
                    <v-btn @click="openDialog = false" class="grey--text mr-3">
                      Cancel
                    </v-btn>
                    <v-btn
                      class="success"
                      :loading="saveLoader"
                      @click="changePassword"
                    >
                      OK
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
        <!-- VIEW END -->
        <inner-page-loader v-else class="main-view"></inner-page-loader>
      </div>
    </div>

    <!-- Snackbar Notification -->
    <v-snackbar
      class="snackbar"
      :color="snackBar.color"
      bottom
      right
      v-model="snackBar.active"
      :multi-line="snackBar.multiLine"
      :timeout="snackBar.timeout"
      >{{ snackBar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import dashboard_Nav from "@/components/dashboard-nav";
import main_Nav from "@/components/mainNav";
import bread_crumb from "@/components/breadcrumb";
import inner_page_loader from "@/components/innerPageLoader";
import { mapState } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      title: "Account",
      openDialog: false,
      changePasswordActive: false,
      deleteLoader: false,
      saveLoader: false,
      oldPassword: "",
      password: "",
      confirmPassword: "",
      userData: {},
      name: "",
      dataReady: false,
      show1: false,
      show2: false,
      show3: false,
      rules: {
        required: (value) => !!value || "Required",
        passwordMatch: (value) =>
          value === this.password || "Password must match",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: null,
      },
    };
  },
  methods: {
    async updateUser() {
      this.saveLoader = true;

      // Detect if file was uploaded
      if (!this.image.type && !this.url) {
        // if no profile image is present

        this.saveLoader = false;
        return alert("Please add a profile image");
      } else if (this.image.type) {
        const file = {
          file: this.image,
          tags: "external_temp",
        };

        await this.$store
          .dispatch("uploadToCloudinary", file)
          .then((response) => {
            if (response.status == 200 || response.status == 201) {
              // set image url
              this.userData.profileImage = response.data.secure_url;
            } else if (response.status != 200 || response.status != 201) {
              this.menuLoader = false;
              alert("Error uploading Image");
              return process.abort();
            }
          });
      }

      axios
        .put("/api/v1/user/", this.userData, {
          headers: { Authorization: this.$store.state.token },
        })
        .then(() => {
          this.saveLoader = false;

          this.snackBar.active = true;
          this.snackBar.text = "Profile updated successfully";
          this.snackBar.color = "success";
          this.snackBar.timeout = this.$store.state.snackBarDuration;
        })
        .catch((error) => {
          this.saveLoader = false;

          this.snackBar.active = true;
          this.snackBar.text =
            error.response.data.message || "Error updating Location";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;
        });
    },
    changePassword() {
      if (this.$refs.dialogForm.validate()) {
        this.saveLoader = true;

        const data = {
          email: this.userData.email,
          oldPassword: this.oldPassword,
          password: this.password,
          confirmPassword: this.confirmPassword,
        };

        axios
          .put("/api/v1/auth/password", data, {
            headers: { Authorization: this.$store.state.token },
          })
          .then(() => {
            this.openDialog = false;
            this.saveLoader = false;

            setTimeout(() => {
              this.snackBar.active = true;
              this.snackBar.text = "Password changed successfully";
              this.snackBar.color = "success";
              this.snackBar.timeout = this.$store.state.snackBarDuration;
            }, 1000);
          })
          .catch((error) => {
            this.saveLoader = false;

            this.snackBar.active = true;
            this.snackBar.text =
              error.response.data.message || "Error updating Location";
            this.snackBar.color = "error";
            this.snackBar.timeout = this.$store.state.snackBarDuration;
          });
      }
    },
    openChangePassword() {
      this.openDialog = true;
      this.changePasswordActive = true;
    },
  },
  watch: {
    openDialog(val) {
      if (val == false) {
        this.$refs.dialogForm.reset();
        this.changePasswordActive = false;
      }
    },
    storedUserDetails(val) {
      if (val) {
        this.dataReady = true;
        // this.userData = this.storedUserDetails;

        // strip off unwanted keys
        //  { this.userData.firstName, this.userData.lastName, this.userData.country, this.userData.phone, this.userData.profileImage } = { data };

        this.userData.email = this.storedUserDetails.email;
        this.userData.lastName = this.storedUserDetails.lastName;
        this.userData.country = this.storedUserDetails.country;
        this.userData.phone = this.storedUserDetails.phone;
        this.userData.profileImage = this.origUrl = this.url = this.storedUserDetails.profileImage;

        // Make image preview show if image exists
        this.url.length > 5
          ? (this.isSelected = true)
          : (this.isSelected = false);
      }
    },
  },
  created() {
    this.$store.dispatch("getUserDetails");
    this.$store.dispatch("updateUserProfile");
  },
  computed: {
    ...mapState(["mainNav", "storedUserDetails"]),
  },
  components: {
    "dashboard-nav": dashboard_Nav,
    "main-nav": main_Nav,
    breadcrumb: bread_crumb,
    "inner-page-loader": inner_page_loader,
  },
  mounted() {},
};
</script>

<style scoped>
a {
  color: #418de7;
}

hr {
  border: 1px solid #d0d0d0;
}
</style>
